import Vue from 'vue'
import Router from 'vue-router'
//登录也
const Login = resolve => require(['@/views/login/login'], resolve);
//远程页
// const noVNC = resolve => require(['@/views/noVNC'], resolve);
//主干也
const Main = resolve => require(['@/views/Main'], resolve);
//监控
const Home = resolve => require(['@/views/homeIndex/home'], resolve);
// 登录-主干页
const LoginMain = resolve => require(['@/views/loginMain'], resolve);
// 注册
const Regist = resolve => require(['@/views/login/regist'], resolve);
// 验证码登录
const LoginCode = resolve => require(['@/views/login/loginCode'], resolve);
// 绑定手机号
const BindMobile = resolve => require(['@/views/login/bindMobile'], resolve);
// 忘记密码
const ForgetPwd = resolve => require(['@/views/login/forgetPwd'], resolve);
// 微信登录中转页
const WxLogin = resolve => require(['@/views/login/wxLogin'], resolve);
// 发布-主干页
const ReleaseMain = resolve => require(['@/views/releaseMain'], resolve);
// 发布-选择类型
const Release = resolve => require(['@/views/release/index'], resolve);
// 发布-论坛
const ForumRelease = resolve => require(['@/views/release/forumRelease'], resolve);
// 发布成功
const ReleaseSuccess = resolve => require(['@/views/release/success'], resolve);
// 发布-入驻商家
const SettleIn = resolve => require(['@/views/release/settleIn'], resolve);
// 置顶结算-入驻商家
const Settlement = resolve => require(['@/views/release/settlement'], resolve);
// 结算-收银台
const Cashier = resolve => require(['@/views/release/cashier'], resolve);
// 支付成功
const PaySuccess = resolve => require(['@/views/release/paySuccess'], resolve);
// 今日折扣
const Discount = resolve => require(['@/views/release/discount'], resolve);
// 发布-本地生活
const ReleaseLocalLife = resolve => require(['@/views/release/localLife'], resolve);
// 发布-二手交易
const SecondTrade = resolve => require(['@/views/release/secondTrade'], resolve);
// 发布-二手车
const UsedCar = resolve => require(['@/views/release/usedCar'], resolve);
// 发布-租房
const ReleaseRentHouse = resolve => require(['@/views/release/rentHouse'], resolve);
// 发布-招聘
const Recruit = resolve => require(['@/views/release/Recruit'], resolve);
// 发布-宠物
const ReleasePet = resolve => require(['@/views/release/pet'], resolve);

// 主页-主干页
const UserMain = resolve => require(['@/views/userMain'], resolve);
// 用户主页
const User = resolve => require(['@/views/user/index'], resolve);
// 个人资料
const PersonalInfo = resolve => require(['@/views/user/personalInfo'], resolve);
// 商家认证
const MerchantAuth = resolve => require(['@/views/user/merchantAuth'], resolve);
// 商家认证-已认证
const ShopCertified = resolve => require(['@/views/user/shopCertified'], resolve);
// 签约作家认证
const WriterAuth = resolve => require(['@/views/user/writerAuth'], resolve);
// 签约作家已认证
const SignedAuthor = resolve => require(['@/views/user/signedAuthor'], resolve);
// 关注/粉丝
const Follow = resolve => require(['@/views/user/follow'], resolve);
// 发布中
const Publishing = resolve => require(['@/views/user/publishing'], resolve);
// 审核中
const InReview = resolve => require(['@/views/user/inReview'], resolve);
// 审核详情
const ReviewDetail = resolve => require(['@/views/user/reviewDetail'], resolve);
// 动态详情
const DynamicReview = resolve => require(['@/views/user/dynamicReview'], resolve);
// 足迹
const History = resolve => require(['@/views/user/history'], resolve);
// 收藏
const Collection = resolve => require(['@/views/user/collection'], resolve);
// 关于我们
const AboutUs = resolve => require(['@/views/user/aboutUs'], resolve);
// 联系我们
const ContactUs = resolve => require(['@/views/user/contactUs'], resolve);
// 意见反馈
const Feedback = resolve => require(['@/views/user/feedback'], resolve);
// 申请状态
const SqStatus = resolve => require(['@/views/user/sqStatus'], resolve);
// 账户密码
const AccountInfo = resolve => require(['@/views/user/accountInfo'], resolve);
// 黑名单
const Blacklist = resolve => require(['@/views/user/blacklist'], resolve);
// 通知中心
const Notice = resolve => require(['@/views/user/notice'], resolve);
// 过渡页
const Transition = resolve => require(['@/views/user/transition'], resolve)
    // 论坛
const BBS = resolve => require(['@/views/BBS/index'], resolve);
// 二手交易
const Trading = resolve => require(['@/views/trading/index'], resolve);
// 租房
const RentHouse = resolve => require(['@/views/rentHouse/index'], resolve);
// 二手车
const TwoHandcart = resolve => require(['@/views/twoHandcart/index'], resolve);
// 招聘
const Recruitment = resolve => require(['@/views/recruitment/index'], resolve);
// 今日折扣
const TodayDiscount = resolve => require(['@/views/todayDiscount/index'], resolve);
// 入驻商家
const Businessman = resolve => require(['@/views/businessman/index'], resolve);
// 宠物
const Pet = resolve => require(['@/views/pet/index'], resolve);
// 本地生活
const LocalLife = resolve => require(['@/views/localLife/index'], resolve);

// 哈法列表
const HafaList = resolve => require(['@/components/details/hafaList'], resolve);
// 哈法详情
const HafaDetails = resolve => require(['@/components/details/hafaDetails'], resolve);
// 论坛详情
const BbsDetails = resolve => require(['@/components/details/bbsDetails'], resolve);
// 二手交易详情入驻商家
const TradingDetails = resolve => require(['@/components/details/tradingDetails'], resolve);
// 本地生活详情
const LocalLifeDetails = resolve => require(['@/components/details/localLifeDetails'], resolve);
// 今日折扣详情
const TodayDiscountDetails = resolve => require(['@/components/details/todayDiscountDetails'], resolve);
// 今日折扣详情
const BusinessmanDetails = resolve => require(['@/components/details/businessmanDetails'], resolve);
// 租房详情
const RentHouseDetails = resolve => require(['@/components/details/rentHouseDetails'], resolve);
// 二手车详情
const TwoHandcartDetails = resolve => require(['@/components/details/twoHandcartDetails'], resolve);
// 宠物详情
const PetDetails = resolve => require(['@/components/details/petDetails'], resolve);
// 招聘详情
const RecruitmentDetails = resolve => require(['@/components/details/recruitmentDetails'], resolve);
// 他人主页
const OthersPage = resolve => require(['@/views/OthersPage'], resolve);
// 举报
const Report = resolve => require(['@/views/report'], resolve);
// 举报成功
const ReportSuccess = resolve => require(['@/views/report/success'], resolve);
// 公告详情
const Announcement = resolve => require(['@/components/details/announcement'], resolve);
// 过渡页
const ComponentsTransition = resolve => require(['@/components/transition'], resolve)
Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [{
            path: '/',
            redirect: '/home'
        },
        {
            path: '/login-main',
            name: 'LoginMain',
            component: LoginMain,
            children: [{
                path: '/login',
                name: 'login',
                component: Login
            }, {
                path: '/regist',
                name: 'Regist',
                component: Regist
            }, {
                path: '/login-code',
                name: 'LoginCode',
                component: LoginCode
            }, {
                path: '/bind-mobile',
                name: 'BindMobile',
                component: BindMobile
            }, {
                path: '/forget-pwd',
                name: 'ForgetPwd',
                component: ForgetPwd
            }, {
                path: '/wxLogin',
                name: 'WxLogin',
                component: WxLogin
            }]
        },
        // {
        //     path: '/vnc',
        //     name: 'vnc',
        //     component: noVNC
        // },
        {
            path: '/',
            name: 'Main',
            component: Main,
            // redirect: '/home',
            children: [{
                path: 'home',
                name: 'home',
                component: Home,
                meta: {
                    keepAlive: false
                }
            }]
        },
        {
            path: '/',
            name: 'Main',
            component: Main,
            children: [{
                path: '/forum',
                name: 'BBS',
                component: BBS,
                meta: {
                    keepAlive: false
                },
            }]
        },
        {
            path: '/',
            name: 'Main',
            component: Main,
            children: [{
                path: '/trading',
                name: 'trading',
                component: Trading,
                meta: {
                    keepAlive: false
                },
            }]
        },
        {
            path: '/',
            name: 'Main',
            component: Main,
            children: [{
                path: '/rentHouse',
                name: 'rentHouse',
                component: RentHouse,
                meta: {
                    keepAlive: false
                }
            }]
        },
        {
            path: '/',
            name: 'Main',
            component: Main,
            children: [{
                path: '/recruitment',
                name: 'recruitment',
                component: Recruitment,
                meta: {
                    keepAlive: false
                }
            }]
        },
        {
            path: '/',
            name: 'Main',
            component: Main,
            children: [{
                path: '/twoHandcart',
                name: 'twoHandcart',
                component: TwoHandcart,
                meta: {
                    keepAlive: false
                }
            }]
        },
        {
            path: '/',
            name: 'Main',
            component: Main,
            children: [{
                path: '/todayDiscountDetails',
                name: 'todayDiscountDetails',
                component: TodayDiscountDetails,
                meta: {
                    keepAlive: false
                }
            }]
        },
        {
            path: '/',
            name: 'Main',
            component: Main,
            children: [{
                path: '/businessmanDetails',
                name: 'businessmanDetails',
                component: BusinessmanDetails,
                meta: {
                    keepAlive: false
                }
            }]
        },
        {
            path: '/',
            name: 'Main',
            component: Main,
            children: [{
                path: '/rentHouseDetails',
                name: 'rentHouseDetails',
                component: RentHouseDetails,
                meta: {
                    keepAlive: false
                }
            }]
        },
        {
            path: '/',
            name: 'Main',
            component: Main,
            children: [{
                path: '/twoHandcartDetails',
                name: 'twoHandcartDetails',
                component: TwoHandcartDetails,
                meta: {
                    keepAlive: false
                }
            }]
        },
        {
            path: '/',
            name: 'Main',
            component: Main,
            children: [{
                path: '/petDetails',
                name: 'petDetails',
                component: PetDetails,
                meta: {
                    keepAlive: false
                }
            }]
        },
        {
            path: '/',
            name: 'Main',
            component: Main,
            children: [{
                path: '/recruitmentDetails',
                name: 'recruitmentDetails',
                component: RecruitmentDetails,
                meta: {
                    keepAlive: false
                }
            }]
        },
        {
            path: '/',
            name: 'Main',
            component: Main,
            children: [{
                path: '/othersPage',
                name: 'othersPage',
                component: OthersPage,
                meta: {
                    keepAlive: false
                }
            }]
        },
        {
            path: '/',
            name: 'Main',
            component: Main,
            children: [{
                path: '/report',
                name: 'report',
                component: Report,
                meta: {
                    keepAlive: false
                }
            }]
        },
        {
            path: '/',
            name: 'Main',
            component: Main,
            children: [{
                path: '/reportSuccess',
                name: 'reportSuccess',
                component: ReportSuccess,
                meta: {
                    keepAlive: false
                }
            }]
        },
        {
            path: '/',
            name: 'Main',
            component: Main,
            children: [{
                path: '/announcement',
                name: 'announcement',
                component: Announcement,
                meta: {
                    keepAlive: false
                }
            }]
        },
        {
            path: '/',
            name: 'Main',
            component: Main,
            children: [{
                path: '/componentsTransition',
                name: 'componentsTransition',
                component: ComponentsTransition,
                meta: {
                    keepAlive: false
                }
            }]
        },
        {
            path: '/',
            name: 'Main',
            component: Main,
            children: [{
                path: '/businessman',
                name: 'businessman',
                component: Businessman,
                meta: {
                    keepAlive: false
                }
            }]
        },
        {
            path: '/',
            name: 'Main',
            component: Main,
            children: [{
                path: '/pet',
                name: 'pet',
                component: Pet,
                meta: {
                    keepAlive: false
                }
            }]
        },
        {
            path: '/',
            name: 'Main',
            component: Main,
            children: [{
                path: '/localLife',
                name: 'localLife',
                component: LocalLife,
                meta: {
                    keepAlive: false
                }
            }]
        },
        {
            path: '/',
            name: 'Main',
            component: Main,
            children: [{
                path: '/hafaList',
                name: 'hafaList',
                component: HafaList,
                meta: {
                    keepAlive: false
                }
            }]
        },
        {
            path: '/',
            name: 'Main',
            component: Main,
            children: [{
                path: '/hafaDetails',
                name: 'hafaDetails',
                component: HafaDetails,
                meta: {
                    keepAlive: false
                }
            }]
        },
        {
            path: '/',
            name: 'Main',
            component: Main,
            children: [{
                path: '/bbsDetails',
                name: 'bbsDetails',
                component: BbsDetails,
                meta: {
                    keepAlive: false
                }
            }]
        },
        {
            path: '/',
            name: 'Main',
            component: Main,
            children: [{
                path: '/tradingDetails',
                name: 'tradingDetails',
                component: TradingDetails,
                meta: {
                    keepAlive: false
                }
            }]
        },
        {
            path: '/',
            name: 'Main',
            component: Main,
            children: [{
                path: '/localLifeDetails',
                name: 'localLifeDetails',
                component: LocalLifeDetails,
                meta: {
                    keepAlive: false
                }
            }]
        },
        {
            path: '/',
            name: 'Main',
            component: Main,
            children: [{
                path: '/todayDiscount',
                name: 'todayDiscount',
                component: TodayDiscount,
                meta: {
                    keepAlive: false
                }
            }]
        },
        {
            path: '/release-main',
            name: 'ReleaseMain',
            component: ReleaseMain,
            children: [{
                path: '/release',
                name: 'Release',
                component: Release,
                meta: {
                    keepAlive: false
                }
            }, {
                path: '/forum-release',
                name: 'ForumRelease',
                component: ForumRelease,
                meta: {
                    keepAlive: false
                }
            }, {
                path: '/release-success',
                name: 'ReleaseSuccess',
                component: ReleaseSuccess,
                meta: {
                    keepAlive: false
                }
            }, {
                path: '/release-settleIn',
                name: 'SettleIn',
                component: SettleIn,
                meta: {
                    keepAlive: false
                }
            }, {
                path: '/settlement',
                name: 'Settlement',
                component: Settlement,
                meta: {
                    keepAlive: false
                }
            }, {
                path: '/cashier',
                name: 'Cashier',
                component: Cashier,
                meta: {
                    keepAlive: false
                }
            }, {
                path: '/pay-success',
                name: 'PaySuccess',
                component: PaySuccess,
                meta: {
                    keepAlive: false
                }
            }, {
                path: '/discount',
                name: 'Discount',
                component: Discount,
                meta: {
                    keepAlive: false
                }
            }, {
                path: '/release-localLife',
                name: 'ReleaseLocalLife',
                component: ReleaseLocalLife,
                meta: {
                    keepAlive: false
                }
            }, {
                path: '/secondTrade',
                name: 'SecondTrade',
                component: SecondTrade,
                meta: {
                    keepAlive: false
                }
            }, {
                path: '/usedCar',
                name: 'UsedCar',
                component: UsedCar,
                meta: {
                    keepAlive: false
                }
            }, {
                path: '/release-rentHouse',
                name: 'ReleaseRentHouse',
                component: ReleaseRentHouse,
                meta: {
                    keepAlive: false
                }
            }, {
                path: '/recruit',
                name: 'Recruit',
                component: Recruit,
                meta: {
                    keepAlive: false
                }
            }, {
                path: '/releasePet',
                name: 'ReleasePet',
                component: ReleasePet,
                meta: {
                    keepAlive: false
                }
            }],
        },
        {
            path: '/userMain',
            name: 'UserMain',
            component: UserMain,
            children: [{
                path: '/user',
                name: 'User',
                component: User,
                meta: {
                    keepAlive: false
                }
            }, {
                path: '/personalInfo',
                name: 'PersonalInfo',
                component: PersonalInfo,
                meta: {
                    keepAlive: false
                }
            }, {
                path: '/merchantAuth',
                name: 'MerchantAuth',
                component: MerchantAuth,
                meta: {
                    keepAlive: false
                }
            }, {
                path: '/shopCertified',
                name: 'ShopCertified',
                component: ShopCertified,
                meta: {
                    keepAlive: false
                }
            }, {
                path: '/writerAuth',
                name: 'WriterAuth',
                component: WriterAuth,
                meta: {
                    keepAlive: false
                }
            }, {
                path: '/signedAuthor',
                name: 'SignedAuthor',
                component: SignedAuthor,
                meta: {
                    keepAlive: false
                }
            }, {
                path: '/follow',
                name: 'Follow',
                component: Follow,
                meta: {
                    keepAlive: false
                }
            }, {
                path: '/publishing',
                name: 'Publishing',
                component: Publishing,
                meta: {
                    keepAlive: false
                }
            }, {
                path: '/inReview',
                name: 'InReview',
                component: InReview,
                meta: {
                    keepAlive: false
                }
            }, {
                path: '/reviewDetail',
                name: 'ReviewDetail',
                component: ReviewDetail,
                meta: {
                    keepAlive: false
                }
            }, {
                path: '/dynamicReview',
                name: 'DynamicReview',
                component: DynamicReview,
                meta: {
                    keepAlive: false
                }
            }, {
                path: '/history',
                name: 'History',
                component: History,
                meta: {
                    keepAlive: false
                }
            }, {
                path: '/collection',
                name: 'Collection',
                component: Collection,
                meta: {
                    keepAlive: true
                }
            }, {
                path: '/aboutUs',
                name: 'AboutUs',
                component: AboutUs,
                meta: {
                    keepAlive: false
                }
            }, {
                path: '/contactUs',
                name: 'ContactUs',
                component: ContactUs,
                meta: {
                    keepAlive: false
                }
            }, {
                path: '/feedback',
                name: 'Feedback',
                component: Feedback,
                meta: {
                    keepAlive: false
                }
            }, {
                path: '/sqStatus',
                name: 'SqStatus',
                component: SqStatus,
                meta: {
                    keepAlive: false
                }
            }, {
                path: '/accountInfo',
                name: 'AccountInfo',
                component: AccountInfo,
                meta: {
                    keepAlive: false
                }
            }, {
                path: '/blacklist',
                name: 'Blacklist',
                component: Blacklist,
                meta: {
                    keepAlive: false
                }
            }, {
                path: '/notice',
                name: 'Notice',
                component: Notice,
                meta: {
                    keepAlive: false
                }
            }, {
                path: '/transition',
                name: 'Transition',
                component: Transition,
                meta: {
                    keepAlive: false
                }
            }]
        }
    ],
    scrollBehavior(to, from, next) {
        return { x: 0, y: 0 } // return的结果, 就是 期望滚动到哪个的位置
    }
})


// WEBPACK FOOTER //
// ./src/router/index.js